module.exports = __webpack_public_path__ + "static/media/banner003.1ba5d093.jpg";